<template>
    <div>
        <van-cell-group style="margin-top:15px;">
            <van-field
                    v-model="model.name"
                    label="名称"
                    type="text"
                    autosize
                    placeholder="请输入名称"
            />
            <van-field label="性别">
                <van-radio-group slot="input" v-model="model.sex" direction="horizontal">
                    <van-radio name="1">男</van-radio>
                    <van-radio name="2">女</van-radio>
                </van-radio-group>
            </van-field>
        </van-cell-group>
        <div class="text-center padding-tb-lg">
            <van-button type="primary" @click="addClerk">下一步，完善资料</van-button>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import { Cell, CellGroup, ActionSheet, Field, Popup, Button, RadioGroup, Radio, Toast, Dialog } from 'vant';
  import { getClerkByDdUserId, addClerk } from '@/api/clerk/clerk'

  Vue.use(Cell)
    .use(CellGroup)
    .use(ActionSheet)
    .use(Field)
    .use(Popup)
    .use(Button)
    .use(RadioGroup)
    .use(Radio)
    .use(Toast)
    .use(Dialog)

  export default {
    name: "clerk-add",
    data () {
      return {
        model: {
            name: null,
            sex: null
        }
      }
    },
    methods: {
      checkSex(value) {
        this.model.sex = value
      },
      loadData() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getClerkByDdUserId().then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            if (data.clerk != null) {
              Dialog.alert({
                title: '您已经是' + this.$store.state.label.clerkLabel + '，请勿重复添加'
              }).then(() => {
                this.$router.replace('/clerk/info')
              })
            }
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      },
      addClerk() {
        if (this.model.name == null || this.model.name == '') {
          return Toast('请输入名称');
        }
        if (this.model.sex == null) {
          return Toast('请选择性别');
        }
        Toast.loading({
          mask: true,
          message: '请稍候'
        })
        addClerk(this.model.name, this.model.sex).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            Toast.success('创建成功');
            this.$router.replace('/clerk/info')
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      }
    },
    mounted() {
      // this.loadData()
    }
  }
</script>

<style lang="less" scoped>

</style>
